export const getStringFromFormDataEntry = (entry: FormDataEntryValue | null) =>
  typeof entry === 'string' ? entry : '';
